var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{ref:"initial",staticClass:"initial"},[_vm._v(_vm._s(_vm.initial))]),_c('span',{staticClass:"highlight"},[_vm._v(_vm._s(_vm.highlighted))]),_c('span',{staticClass:"tail"},[_vm._v(_vm._s(_vm.tail))])])}
var staticRenderFns = []

export { render, staticRenderFns }